import { loanApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOANS_BORROWERS_ACTION_TYPE = createNamedActions('loansBorrowersActions', {
  GET_LOANS_BORROWERS_OPTIONS: 'GET_LOANS_BORROWERS_OPTIONS',
});

export const getLoansBorrowersAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await loanApi.getLoanBorrowers();

  return dispatch({
    type: LOANS_BORROWERS_ACTION_TYPE.GET_LOANS_BORROWERS_OPTIONS,
    payload: data,
  });
});
